import React, { Component } from 'react';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { Group, Loader, Stack } from '@mantine/core';
import CustomModal from './index';
import ColorButton from '../Buttons/ColorButton';
import InvoicePdfTemplate from '../../../../../views/pages/Module/General/profile/InvoiceTemplatePdf.jsx';

var JSZip = require('jszip');

export class BulkDownloadInvoicesModal extends Component {
  state = {
    processing: true,
    processingIndex: 0,
    generatedFiles: [],
  };

  handlePdfGenerated = (file) => {
    const { invoices } = this.props;
    const { processingIndex, generatedFiles } = this.state;
    const invoice = invoices[processingIndex];
    const nextGeneratedFiles = [...generatedFiles, { invoice, file }];
    const nextIndex = processingIndex + 1;

    this.setState({
      generatedFiles: nextGeneratedFiles,
      processingIndex: nextIndex,
      processing: nextIndex < invoices.length,
    });
  };

  downloadZip = () => {
    const { generatedFiles } = this.state;
    const zip = new JSZip();
    const fileNames = [];

    const uniqueFileName = (baseName, index = 0) => {
      const candidate = index === 0 ? baseName : `${baseName}_${index}`;
      return fileNames.includes(`${candidate}.pdf`) ? uniqueFileName(baseName, index + 1) : candidate;
    };

    generatedFiles.forEach(({ invoice, file }) => {
      const baseName = `${dayjs(invoice.invoiceDate).format('YYYYMMDD')}_Rechnung-${invoice.invoiceNumber}`;
      const name = uniqueFileName(baseName);
      fileNames.push(`${name}.pdf`);
      zip.file(`${name}.pdf`, file);
    });

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${dayjs().format('YYYYMMDD_HHmm')}_Rechnungen.zip`);
      this.props.toggle();
    });
  };

  render() {
    const { open, toggle, className, invoices } = this.props;
    const { processing, processingIndex } = this.state;

    return (
      <CustomModal
        heading={'Rechnungen herunterladen'}
        open={open}
        toggle={() => toggle()}
        className={className}
      >
        <Stack style={{ minHeight: 'inherit' }} justify="space-between">
          {processing ? (
            <Group justify="center" align="flex-end" gap={6} style={{ padding: '20px 0px' }}>
              <span style={{ fontWeight: 400 }}>{`PDF wird erstellt (${Math.min(processingIndex + 1, invoices.length)}/${invoices.length})`}</span>
              <Loader size={16} type="dots" />
            </Group>
          ) : (
            <Stack style={{ padding: '0px 0px 20px 0px' }}>
              <span style={{ fontWeight: 400 }}>Die Rechnungen können jetzt heruntergeladen werden.</span>
            </Stack>
          )}

          <Group justify="space-between" style={{ marginTop: 10, width: '100%' }}>
            <div>
              <ColorButton text={'Abbrechen'} className="gray-btn" onClick={() => toggle()} />
            </div>
            <div>
              <ColorButton text={'Herunterladen'} className="purple-btn" disabled={processing} onClick={() => this.downloadZip()} />
            </div>
          </Group>
        </Stack>

        {processing && processingIndex < invoices.length && (
          <div style={{ position: 'absolute', top: -99999, left: -99999, visibility: 'hidden' }}>
            <InvoicePdfTemplate
              key={invoices[processingIndex].id}
              id={invoices[processingIndex].id}
              background
              onPdfGenerated={this.handlePdfGenerated}
            />
          </div>
        )}
      </CustomModal>
    );
  }
}

export default BulkDownloadInvoicesModal;
